import React, { useState } from 'react';
import { MapPin, Search } from 'lucide-react';
import { belgianCities } from '../mockData';

const Cities = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAll, setShowAll] = useState(false);
  
  const filteredCities = belgianCities.filter(city => 
    city.toLowerCase().includes(searchTerm.toLowerCase())
  );
  
  const displayedCities = showAll ? filteredCities : filteredCities.slice(0, 4);
  
  return (
    <section id="villes" className="py-16 md:py-32 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/30 to-black"></div>
      
      <div className="absolute bottom-0 left-1/3 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            Marabout dans <span className="gold-text">toute la Belgique</span>
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10 serif-font">
            Services disponibles dans toutes les villes de Belgique. Consultations en personne ou à distance.
          </p>
          
          <div className="max-w-md mx-auto relative">
            <input
              type="text"
              placeholder="Rechercher votre ville..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full glass border-2 border-yellow-500/30 rounded-full px-6 py-4 pl-14 text-white placeholder-gray-400 focus:outline-none focus:border-yellow-500 transition-all text-lg"
            />
            <Search className="absolute left-5 top-1/2 transform -translate-y-1/2 text-yellow-500" size={24} />
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
          {displayedCities.map((city, index) => (
            <div 
              key={index}
              className="card-hover glass rounded-2xl p-6 text-center group"
              style={{animationDelay: `${(index % 20) * 0.05}s`}}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform shadow-lg">
                <MapPin className="text-white" size={28} />
              </div>
              <p className="text-white font-semibold text-lg">{city}</p>
            </div>
          ))}
        </div>
        
        {!showAll && filteredCities.length > 40 && (
          <div className="text-center mt-16">
            <button
              onClick={() => setShowAll(true)}
              className="luxury-button text-white px-10 py-5 rounded-full font-bold text-lg"
            >
              Voir toutes les villes ({filteredCities.length})
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Cities;